var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 13.6673C3.31816 13.6673 0.333496 10.6827 0.333496 7.00065C0.333496 3.31865 3.31816 0.333984 7.00016 0.333984C10.6822 0.333984 13.6668 3.31865 13.6668 7.00065C13.6668 10.6827 10.6822 13.6673 7.00016 13.6673ZM6.3335 6.33398V10.334H7.66683V6.33398H6.3335ZM6.3335 3.66732V5.00065H7.66683V3.66732H6.3335Z",
    fill: "#B9B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon16X16);
export default __webpack_public_path__ + "static/media/info_icon_16x16.849014f30379783d9f793b9f874acbc3.svg";
export { ForwardRef as ReactComponent };